<script>
  import { onMount } from 'svelte';
  import { theme } from '$stores/themeStore';
  import { user } from '$stores/sessionStore';

  let changelogContent = '';
  let loading = true;
  let error = null;

  onMount(async () => {
    try {
      // Fetch the changelog CONTENT from a real static asset, NOT '/changelog'
      // (that is this page's own SPA route — nginx's try_files fallback would
      // return index.html and the page would render raw HTML: SPTL-737).
      // public/changelog.md is copied to the web root by Vite and served
      // directly by nginx.
      const response = await fetch('/changelog.md', { headers: { Accept: 'text/markdown, text/plain' } });
      if (!response.ok) {
        throw new Error(`Failed to load changelog: ${response.status} ${response.statusText}`);
      }
      changelogContent = await response.text();
      loading = false;
    } catch (err) {
      console.error('Error loading changelog:', err);
      error = err.message;
      loading = false;
    }
  });
</script>

<div class="p-6 max-w-4xl mx-auto">
  <h1 class="text-2xl font-bold mb-0 text-sky-800 dark:text-sky-400">Summa Cloud Changelog</h1>
  
  {#if loading}
    <div class="flex justify-center py-10">
      <div class="animate-spin rounded-full h-10 w-10 border-b-2 border-sky-700"></div>
    </div>
  {:else if error}
    <div class="bg-red-100 dark:bg-red-900 border border-red-400 text-red-700 dark:text-red-200 px-4 py-3 rounded">
      <p>Error loading changelog: {error}</p>
    </div>
  {:else}
    <div class="bg-white dark:bg-gray-700 p-6 markdown-content">
      {#each changelogContent.split('\n') as line}
        {#if line.startsWith('# ')}
          <h1 class="text-2xl font-bold mt-4 mb-2 text-sky-800 dark:text-sky-400">{line.substring(2)}</h1>
        {:else if line.startsWith('## ')}
          <h2 class="text-lg font-bold mt-8 mb-0 text-sky-700 dark:text-sky-300">{line.substring(3)}</h2>
        {:else if line.startsWith('### ')}
          <h3 class="text-sm font-bold mt-1 mb-1 text-sky-600 dark:text-sky-200">{line.substring(4)}</h3>
        {:else if line.startsWith('- ')}
          <ul class="list-disc pl-5 mb-2 text-sm text-black dark:text-white">
            <li>{line.substring(2)}</li>
          </ul>
        {:else if line.startsWith('*') && line.endsWith('*')}
          <p class="italic text-sm my-1 text-gray-600 dark:text-gray-300">{line.substring(1, line.length - 1)}</p>
        {:else if line.startsWith('```')}
          <!-- Skip code blocks for simple display -->
        {:else}
          <p class="my-2">{line}</p>
        {/if}
      {/each}
    </div>
  {/if}
  
  <!-- <div class="mt-6">
    <a 
      href="/" 
      class="inline-block px-4 py-2 bg-sky-600 hover:bg-sky-700 text-white rounded transition-colors"
    >
      Back
    </a>
  </div> -->
</div>

<style>
  .markdown-content {
    line-height: 1.6;
  }
  
  .markdown-content ul {
    margin-left: 1.5rem;
  }
  
  .markdown-content p {
    margin-bottom: 0.75rem;
  }
</style> 